module.exports = __webpack_public_path__ + "static/media/bower.f22ed462.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/bower.png
// module id = 46
// module chunks = 0